import { useMediaSrc } from '../library/useMediaSrc'
import type { OfUser } from './posts'

/** A round OnlyFans avatar (initial until the picture loads). */
export function Avatar({ user, size = 40, url }: { user?: Pick<OfUser, 'name' | 'avatar'>; size?: number; url?: string }) {
  const { ref, src } = useMediaSrc(url ?? user?.avatar ?? '')
  return (
    <span ref={ref as React.RefObject<HTMLSpanElement>} className="ofp-avatar" style={{ width: size, height: size, fontSize: size * 0.4 }} aria-hidden="true">
      {src ? <img src={src} alt="" /> : (user?.name ?? '').replace(/[^\p{L}\p{N}]/gu, '').slice(0, 1).toUpperCase()}
    </span>
  )
}
